export const CartItemResource = (data = {}) => {
	return {
		id: data.uid || data.product_id,
		title: data.title,
		description: data.description || null,
		quantity: data.quantity || 0,
		thumb: data.thumb || {},
		price: data.price || 0,
		service_charge: data.service_charge || 0,
		product_family: data.product_family ? data.product_family.slug : null,
		main_category: data.main_category || null,
		food_provider: data.food_provider || null,
		is_combo_product: data.is_combo_product ? true : false,
		combo_items: data.combo_items || {},
		max_quantity_per_order: data.max_quantity_per_order || null,
		badge: data.badge || null,
		sellerId: data.sellerId || null,
		variants: data.variants || null,
		customized_lighter_name: data.customized_lighter_name || null,
	};
};
